import { graphql } from "@/graphql/generated/gql";

export const createDashboardExportMutationDocument = graphql(/* GraphQL */ `
  mutation createDashboardExport($input: CreateDashboardExportInput!) {
    createDashboardExport(input: $input) {
      id
      status
    }
  }
`);

export const latestDashboardExportQueryDocument = graphql(/* GraphQL */ `
  query latestDashboardExport($workspaceId: String!, $dashboardId: String!) {
    latestDashboardExport(workspaceId: $workspaceId, dashboardId: $dashboardId) {
      id
      status
      format
      fileId
      fileName
      downloadedAt
      completedAt
      createdAt
    }
  }
`);

export const dashboardExportListQueryDocument = graphql(/* GraphQL */ `
  query dashboardExportList($input: GetDashboardExportListInput!) {
    dashboardExportList(input: $input) {
      items {
        id
        dashboardId
        format
        status
        watermark
        isPremium
        fileId
        fileName
        completedAt
        downloadedAt
        createdAt
      }
      totalCount
    }
  }
`);

export const markDashboardExportDownloadedMutationDocument = graphql(/* GraphQL */ `
  mutation markDashboardExportDownloaded($workspaceId: String!, $id: String!) {
    markDashboardExportDownloaded(workspaceId: $workspaceId, id: $id) {
      id
      downloadedAt
    }
  }
`);
